export default function Logo({ type = 'logo', className = 'max-w-32', ...props }) {
    let logoSrc = '/images/logo/logo.png'

    if (type === 'dark') {
        logoSrc = '/images/logo/logo-dark.png'
    }

    return <img src={logoSrc} alt={type} className={`${className}`} {...props} />
}
